/**
 * 解析钱包授权接口响应，与借贷资产页逻辑一致。
 * @param {*} authRes checkAuthStatus 响应
 * @param {*} infoRes getUserWalletInfo 响应
 */
export function parseWalletAuthStatus(authRes, infoRes) {
	let authStatus = {}
	if (authRes && (authRes.code == 200 || authRes.code == '200')) {
		const data = authRes.data
		if (typeof data === 'object' && data !== null) {
			authStatus = { ...data }
		} else {
			authStatus = { isAuthorized: !!data }
		}
	}
	if (infoRes && (infoRes.code == 200 || infoRes.code == '200')) {
		const walletInfo = infoRes.data || {}
		if (!authStatus.usdtAuthorized && walletInfo.usdtAllowed != null) {
			authStatus.usdtAuthorized = Number(walletInfo.usdtAllowed) > 0
		}
		if (!authStatus.usdcAuthorized && walletInfo.usdcAllowed != null) {
			authStatus.usdcAuthorized = Number(walletInfo.usdcAllowed) > 0
		}
	}
	return authStatus
}

export function isWalletTokenAuthorized(authStatus) {
	if (!authStatus || typeof authStatus !== 'object') return false
	if (authStatus.usdtAuthorized || authStatus.usdcAuthorized) return true
	return !!authStatus.isAuthorized
}
